module.exports = __webpack_public_path__ + "img/x.b2ff5671.png";